import { Button } from 'designsystem/Button'
import React from 'react'
import { HighlightedLink as HighlightedLinkTypes } from 'types/generated/contentful'
import IconRenderer from './marketing/IconRenderer'

interface HighlightedLinkProps
  extends React.HtmlHTMLAttributes<HTMLDivElement> {
  entry: HighlightedLinkTypes
}

export default function HighlightedLink({
  entry,
  className,
  ...props
}: HighlightedLinkProps): JSX.Element | null {
  const { type, title, subline, buttonText, buttonUrl } = entry

  return type && title && subline && buttonText && buttonUrl ? (
    <div
      className={`my-30 sm:my-40 w-screen ml-[calc((100vw-100%)/2*-1)] ${
        className || ''
      }`}
      {...props}
    >
      <div className='horizontal-padding max-w-896 mx-auto sm:flex sm:flex-col sm:text-center sm:justify-center sm:items-center'>
        <IconRenderer
          icon={
            type === 'documentation'
              ? 'documentation'
              : type === 'plugin'
                ? 'plugin'
                : 'diamond'
          }
          className='text-blue h-16 md:h-20 w-auto'
        />

        <h2 style={{ marginTop: 32 }}>{title}</h2>

        <p className='text-neutral-60' style={{ marginTop: 12 }}>
          {subline}
        </p>

        <a
          className='block spacer-sm w-fit-content'
          href={buttonUrl}
          target='_blank'
          rel='noreferrer'
        >
          <Button pageType='marketing' color='blue' tabIndex={-1}>
            {buttonText}
          </Button>
        </a>
      </div>
    </div>
  ) : null
}
